import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=413bad45&"
import script from "./forgetpassword.vue?vue&type=script&lang=js&"
export * from "./forgetpassword.vue?vue&type=script&lang=js&"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports